

































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class BoutonChrono extends Vue {
	@Prop({ required: true })
	grandeperiode!: any;

	@Prop({ required: true })
	index!: number;

	@Prop({ required: true })
	opened!: boolean;

	private timeoutId: null | number = null;

	get imgUrl() {
		let fileName = this.grandeperiode.icon;
		if (!this.isActiveGrandePeriode) {
			fileName += '-light';
		}
		return require('@/assets/img/' + fileName + '.svg');
	}

	get absoluteImage() {
		return require('@/assets/img/menu/' +
			this.grandeperiode.icon +
			'-img.png');
	}

	get isActiveGrandePeriode() {
		return this.index == this.$store.getters['getActiveGrandePeriodeIndex'];
	}

	setActiveGrandePeriodeIndex(): void {
		if (this.$store.getters.getIsMobile) {
			let element: HTMLElement | null = document.querySelectorAll('.grande-periode')[this.index] as HTMLElement;

			if (element !== null) {
				let position = element.offsetTop;
				let container: HTMLElement | null = document.querySelector('.grandes-periodes-wrapper');
				if (container !== null) {
					container.scrollTop = position + 10;
				}
			}
		} else {
			this.$store.commit('setActiveGrandePeriodeIndex', this.index);

			if (!this.timeoutId) {
				this.timeoutId = setTimeout(() => {
					// simple click
				}, 50); //tolerance in ms
			} else {
				clearTimeout(this.timeoutId);
				this.onDoubleClick();
			}
		}
	}

	@Emit('double-clicked')
	onDoubleClick(): void {}
}
